import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField } from '@mui/material';

export function CreateChannelScenarioModal({ onClose }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    startDate: '',
    endDate: '',
    budget: ''
  });

  const formatBudget = (value) => {
    const digits = value.replace(/\D/g, '');
    const formatted = Number(digits).toLocaleString();
    return digits ? `$${formatted}` : '';
  };

  const handleBudgetChange = (e) => {
    const rawValue = e.target.value.replace(/[^0-9]/g, '');
    setFormData(prev => ({
      ...prev,
      budget: formatBudget(rawValue)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const newScenario = {
      id: Date.now(),
      name: formData.name,
      dateRange: `${formData.startDate} - ${formData.endDate}`,
      budget: formData.budget,
      channelsSelected: 0
    };

    const existingScenarios = JSON.parse(localStorage.getItem('channelScenarios') || '[]');
    localStorage.setItem('channelScenarios', JSON.stringify([...existingScenarios, newScenario]));

    navigate(`/channels/select/${newScenario.id}`);
  };

  const isFormValid = formData.name && formData.startDate && formData.endDate && formData.budget;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Create New Channel Scenario</h2>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Scenario Name</label>
            <TextField
              value={formData.name}
              onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
              placeholder="Enter scenario name"
              fullWidth
            />
          </div>

          <div className="form-group">
            <label>Time Period</label>
            <div className="date-inputs">
              <input
                type="date"
                value={formData.startDate}
                onChange={(e) => setFormData(prev => ({ ...prev, startDate: e.target.value }))}
                required
              />
              <span>to</span>
              <input
                type="date"
                value={formData.endDate}
                onChange={(e) => setFormData(prev => ({ ...prev, endDate: e.target.value }))}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>Total Budget</label>
            <TextField
              value={formData.budget}
              onChange={handleBudgetChange}
              placeholder="Enter budget"
              fullWidth
            />
          </div>

          <div className="modal-actions">
            <button type="button" className="button-secondary" onClick={onClose}>
              Cancel
            </button>
            <button 
              type="submit" 
              className="button-primary"
              disabled={!isFormValid}
            >
              Create Scenario
            </button>
          </div>
        </form>
      </div>
    </div>
  );
} 